<template>
  <div v-loading="loading">
    <div class="m-b-10 ovf-hd">
      <div class="fl w-120 m-r-10">
        <el-input placeholder="来源" v-model="source"></el-input>
      </div>
      <div class="fl w-120 m-r-10">
        <el-input placeholder="接收人" v-model="receiver"></el-input>
      </div>
      <div class="fl w-150  m-r-10">
        <el-select v-model="statusValue" placeholder="状态">
          <el-option
              v-for="item in options"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="fl w-120">
        <el-button type="primary" @click="search()">搜索</el-button>
      </div>
    </div>
    <el-table
        :data="tableData"
        style="width: 100%"
    >
      <el-table-column
          prop="sign"
          label="通道名称">
      </el-table-column>
      <el-table-column
          label="状态">
        <template scope="scope">
          {{scope.row.status | messageStatus}}
        </template>
      </el-table-column>
      <el-table-column
          prop="source"
          label="来源">
      </el-table-column>
      <el-table-column
          prop="realname"
          label="接收人">
      </el-table-column>
      <el-table-column
          prop="create_time"
          label="提交时间">
        <template scope="scope">
          <span>{{scope.row.create_time | toTime}}</span>  
        </template>  
      </el-table-column>
      <el-table-column
          prop="planned_time"
          label="计划时间">
        <template scope="scope">
          <span>{{scope.row.planned_time | toTime}}</span>  
        </template>  
      </el-table-column>
      <el-table-column
          prop="send_time"
          label="发送时间">
        <template scope="scope">
          <span>{{scope.row.send_time | toTime}}</span>  
        </template>  
      </el-table-column>
      <el-table-column
          label="操作">
        <template scope="scope">
          <div>
            <span v-if="scope.row.status == 20">
              <el-button type="primary" size="small" @click="openReason(scope.row)">查看原因</el-button>
            </span>
            <span v-if="scope.row.status == 20">
              <el-button size="small" @click="retryPush(scope.row)">重试</el-button>
            </span>
            <span v-if="scope.row.status == 20 || scope.row.status == 10">
              <el-button size="small" @click="confirmCancel(scope.row)">取消</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="m-t-20 ovf-hd">
      <el-button type="warning" @click="sendAllRetry()">全部重试</el-button>
      <el-button type="default" @click="sendAllCancel()">全部取消</el-button>
    </div>
    <div class="pos-rel p-t-20">
      <div class="block pages">
        <el-pagination
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :page-size="limit"
            :current-page="currentPage"
            :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import http from '../../../assets/js/http'

  export default {
    data() {
      return {
        tableData: [],
        multipleSelection: [],
        dataCount: null,
        currentPage: null,
        limit: 15,
        options: [{
          value: ' ',
          label: '全部状态'
        }, {
          value: '10',
          label: '待发送'
        }, {
          value: '20',
          label: '失败'
        }, {
          value: '30',
          label: '成功'
        }, {
          value: '40',
          label: '取消'
        }],
        statusValue: '',
        source: '',
        receiver: ''
      }
    },
    methods: {
      async getAllMessage() {
        this.loading = true
        let query = {
          params: {
            limit: this.limit,
            page: this.currentPage
          }
        }
        await this.apiGet('msg/message', query).then((res) => {
          if (res.code == 200) {
            this.loading = false
            this.tableData = res.data.list
            this.dataCount = res.data.dataCount
          }
        })
      },
      search() {
        this.apiGet('msg/message?receiver=' + this.receiver + '&source=' + this.source + '&status=' + this.statusValue + '&page=' + this.currentPage + '&limit=' + this.limit).then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.list
            this.dataCount = res.data.dataCount
          }
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      confirmCancel(item) {
        this.$confirm('确认要取消该推送消息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var postData = {
            id: item.id
          }
          this.apiPost('msg/message/cancel', postData).then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '取消成功')
              setTimeout(() => {
                _g.reloadPage(this)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        })
      },
      handleCurrentChange(page) {
        router.push({ name: 'messageList', query: { limit: this.limit, page: page, receiver: this.receiver, source: this.source, status: this.statusValue }})
      },
      init() {
        this.getCurrentPage()
        this.getAllMessage()
      },
      openReason(item) {
        this.apiGet('msg/message/cause/' + item.id).then((res) => {
          if (res.code == 200) {
            this.$msgbox({
              title: '推送失败的原因',
              message: res.data.cause
            })
          } else {
            _g.dealError(this, res)
          }
        })
      },
      retryPush(item) {
        this.$confirm('确认要重试推送该消息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var postData = {
            id: item.id
          }
          this.apiPost('msg/message/retry', postData).then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '成功重试推送,请等待发送..')
              setTimeout(() => {
                _g.reloadPage(this)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        })
      },
      sendAllRetry() {
        this.$confirm('确认要重试所有推送失败消息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.apiPost('msg/message/retryAll').then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '成功重试推送所有失败的消息,请等待发送..')
              setTimeout(() => {
                _g.reloadPage(this)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        })
      },
      sendAllCancel() {
        this.$confirm('确认要取消全部待发送与失败的消息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.apiPost('msg/message/cancelAll').then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '成功取消全部待发送与失败的消息')
              setTimeout(() => {
                _g.reloadPage(this)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        })
      }
    },
    created() {
      this.init()
    },
    filters: {
      messageStatus(value) {
        let status = ''
        switch (value) {
          case 10:
            status = '待发送'
            break
          case 20:
            status = '失败'
            break
          case 30:
            status = '成功'
            break
          case 40:
            status = '已取消'
            break
          default:
            status = '未知状态'
            break
        }
        return status
      }
    },
    watch: {
      '$route'(to, from) {               // 监听路由改变
        this.init()
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?17b78640